export default {
    isLoggedIn: state => state.isLoggedIn,
    isUrlAvatar: state => state.isUrlAvatar,
    isLoading: state => state.isLoading,
};
